
'use strict';
angular.module('app')
    .directive('customOnChange', function() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var onChangeFunc = scope.$eval(attrs.customOnChange);
                element.bind('change', onChangeFunc);
            }
        };
    });

angular.module('app')
    .directive('modal', [function () {
        return {
            template: "<div class='modal fade' >" +
                            "<div class='modal-dialog' ng-class='sizeClass()'>" +
                                "<div class='modal-content'>" +
                                    "<div class='modal-header bg-blue-pt'>" +
                                        "<button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>" +
                                        "<h4 class='modal-title '><b>{{ title }}</b></h4>" +
                                    "</div>" +
                                    "<div class='modal-body' ng-transclude></div>" +
                                    "</div>" +
                                "</div>" +
                            "</div>"+
                     "</div>",
            restrict: 'E',
            transclude: true,
            replace:true,
            scope:true,
            link: function postLink(scope, element, attrs) {
                scope.title = attrs.title;
                scope.size = attrs.size;
                scope.sizeClass = function(){
                    return scope.size;
                };
                scope.$watch(attrs.visible, function(value){
                    if(value == true)
                        $(element).modal('show');
                    else
                        $(element).modal('hide');
                });

                $(element).on('shown.bs.modal', function(){
                    scope.$apply(function(){
                        scope.$parent[attrs.visible] = true;
                    });
                });

                $(element).on('hidden.bs.modal', function(){
                    scope.$apply(function(){
                        scope.$parent[attrs.visible] = false;
                    });
                });
            }
        };
    }]);

angular.module('app').filter('subString', function () {

    return function (item,a,b) {
        if(item != null && item.length > 0){
            return item.substring(a,b);
        }
    };
});

angular.module('app').directive('errSrc', function() {
    return {
        link: function(scope, element, attrs) {

            scope.$watch(function() {
                return attrs['ngSrc'];
            }, function (value) {
                if (!value) {
                    element.attr('src', attrs.errSrc);
                }
            });

            element.bind('error', function() {
                element.attr('src', attrs.errSrc);
            });
        }
    }
});


angular.module('app').
directive('spanStatusPurchase', function() {
    return {
        restrict: 'E',
        scope: {
            id :"=",
            name :"=",
        },
        template: '<span class="badge" ng-class="{ \'badge-prepared\':id == 8, \'badge-preparing\':id == 7,\'badge-success\':id == 5, \'badge-primary\':id == 6,\'badge-warning\':id == 1,\'badge-info\':id == 2,\'badge-danger\':id == 3,\'badge-primary\':id == 7,\'badge-danger\':id == 8,\'badge-green\':id == 9,\'badge-success\':id == 10}">'+
                            '{{name}}' +
                        '</span>'

    };
});


angular.module('app').
directive('spanNotInfo', function() {
    return {
        restrict: 'E',
        scope: {
            value :"="
        },
        template: '<span ng-show="value">{{ value }}</span><span ng-show="!value">Sin info.</span>'

    };
});
